import { ATH } from '../types';
export default {
  type: ATH,
  service: 'wallet.atheios.com',
  url: 'https://wallet.atheios.com',
  port: 8797,
  auth: false,
  username: '',
  password: ''
};
